import { Http } from "../Http";
import { ApiResponse } from "../../../Api/Model/ApiResponse.csharp";
import {ContactFormRequest} from "@apiModels/ContactFormRequest.csharp";

export interface IContactFormApi {
  contactForm(
    data: ContactFormRequest
  ): Promise<ApiResponse>;
}

export class ContactFormApi implements IContactFormApi {
  public contactForm = (
      data: ContactFormRequest
  ): Promise<ApiResponse> => {
    return Http.post(
      `/api/contact-form`, 
        data, 
        "application/json"
    ) as Promise<ApiResponse>;
  };
}
